import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Nav from "../main/nav";
import Footer from "../main/footer";
import ImportHeader from "../main/ImportHeader";
import ImportRatioChart from "./ImportRetioChart";
import axios from "axios";
import Swal from "sweetalert2";
import ChartGridView from "../main/ChartGridView";
import { ApiBaseUrl } from "../../Config";

export default function ImportIndex() {
  const [ImportChart, setImportChart] = useState([]);
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState("");
  const [ids, setIds] = useState([]);
  const Colors = ["#FFBB28", "#00C49F", "#0088FE", "#A28EFF", "#FF8042",'#93DCFF'];

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${ApiBaseUrl}/warehouse/map/dashboard?warehouse_name=Import`
        );

        const Data = response.data?.data ?? {};

        setImportChart([
          {
            label: "hold_cargo",
            name: "Hold-Cargo",
            value: Data?.hold_cargo_sqm,
            grid: Data?.hold_cargo,
            ids: Data?.hold_cargo_ids,
          },
          {
            label: "unassigned",
            name: "Unassigned with Cargo",
            value: Data?.unassigned_sqm,
            grid: Data?.unassigned,
            ids: Data?.unassigned_ids,
          },
          {
            label: "assigned",
            name: "Assigned with Cargo",
            value: Data?.assigned_sqm,
            grid: Data?.assigned,
            ids: Data?.assigned_ids,
          },
          {
            label: "partially",
            name: "Partially Occupied with assigned / unassigned Cargo",
            value: Data?.partially_sqm,
            grid: Data?.partially,
            ids: Data?.partially_ids,
          },
          {
            label: "available",
            name: "Available",
            value: Data?.available_sqm,
            grid: Data?.available,
            ids: Data?.available_ids ,
          },
          {
            label: "total",
            name: "Total",
            value: Data?.available_sqm+Data?.hold_cargo_sqm+Data?.unassigned_sqm+Data?.assigned_sqm+Data?.partially_sqm,
            grid: Data?.available+Data?.hold_cargo+Data?.unassigned+Data?.assigned+Data?.partially,
            ids: Data?.available_ids+Data?.hold_cargo_ids+Data?.unassigned_ids+Data?.assigned_ids+Data?.partially_ids,
          },
        ]);
      } catch (error) {
        Swal.fire({
          icon: "error",
          text: `Error fetching data: ${error.message}`,
          timer: 3000,
          showConfirmButton: false,
        });
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <ImportHeader />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <h1 className="text-center text-primary">Welcome to Import </h1>
                <div className="row gy-6">
                  <div className="col-md-6">
                    <div className="card box_shadow">
                      <div className="card-body">
                        <p className="m-0">Warehouse Name</p>
                        <h5 className="mt-0">Import Warehouse</h5>

                        <div className="container text-center my-4">
                          <table className="text-center table table-borderless">
                            <thead>
                              <tr>
                                <th colSpan={6} className="fw-bold">
                                  GRID POSITION - (OCCUPIED &amp; AVAILABLE
                                  GRID)
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                {ImportChart?.map((chartData, i) => (
                                  <td
                                    style={{ backgroundColor: Colors[i] }}
                                    className="text-dark fw-bold p-1 pb-0"
                                  >
                                    <small> {chartData?.name}</small>
                                  </td>
                                ))}
                              </tr>
                              <tr>
                                {ImportChart?.map((chartData, i) => (
                                  <td
                                    style={{ backgroundColor: Colors[i] }}
                                    className="text-dark fw-bold"
                                    data-bs-toggle="modal"
                                    data-bs-target="#exampleModal"
                                    onClick={() => {
                                      setType(chartData?.label);
                                      setIds(chartData?.ids);
                                      
                                    }}
                                  >
                                    {chartData?.grid}
                                  </td>
                                ))}
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <ImportRatioChart
                          data={ImportChart}
                          COLORS={Colors}
                          isShowLegend={false}
                          isCustomLegend={true}
                        />
                        <div className="links">
                          <div className="mb-2 mt-2 text-center"></div>
                          <div className="d-flex gap-3 justify-content-between">
                            <Link
                              to={"/import/map"}
                              className="btn btn-label-primary"
                            >
                              <i className="ri ri-store-2-line ri-38px text-primary"></i>
                              Warehouse
                            </Link>

                            <Link
                              to={"/import-cargo"}
                              className="btn btn-label-primary"
                            >
                              <i className="ri ri-contract-line ri-38px text-primary"></i>
                              Active Jobs
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="card box_shadow">
                      <div className="card-body">
                        <p className="m-0">Warehouse Name</p>
                        <h5 className="mt-0">Open Yard</h5>
                        <ImportRatioChart
                          data={[{ name: "Available", value: 1 }]}
                          COLORS={["#FF8042"]}
                          isShowLegend={false}
                          isCustomLegend={true}
                        />
                        <div className="links mt-2">
                          <div className="d-flex gap-3 justify-content-center mt-2">
                            <Link
                              to={"/import-cargo"}
                              className="btn btn-label-primary"
                            >
                              <i className="ri ri-contract-line ri-38px text-primary"></i>
                              Active Jobs
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="exampleModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header py-3 bg-label-primary">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Grid Details
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              {type && ids&&
              (

              <ChartGridView warehouse_name={`Import`} type={type}  ids={ids}/>
              )}
            </div>
            <div className="modal-footer  py-3 bg-label-primary">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
